/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React from "react";
import { useDispatch } from "react-redux";
import { App } from "../../api/apiCalls";
import { MainPageEvent, useMainPageDataSelector } from "../MainUi";
import Modal from "react-bootstrap/Modal";

interface SubscriptionModalProps {
  app: App | undefined;
}

function SubscriptionModal({ app }: SubscriptionModalProps) {
  const dispatch = useDispatch();
  const mainPageData = useMainPageDataSelector();

  const subscribingAction = () => {
    const subReq = {
      appId: app?.appId,
      msisdn: mainPageData.appUser?.msisdn,
      action: 1,
    };
    dispatch({
      type: MainPageEvent.SUBSCRIBE,
      payload: subReq,
      token: mainPageData.authToken ? mainPageData.authToken : null,
    });
  };

  const hideSubscriptionModalAction = () => {
    dispatch({
      type: MainPageEvent.HIDE_SUBSCRIPTION_MODAL,
    });
  };

  const subscriptionNcs = app?.ncses?.find(
    (ncs) => ncs.ncsType === "subscription"
  );

  return (
    <Modal
      show={mainPageData.showSubscriptionModal}
      onHide={() => {
        hideSubscriptionModalAction();
      }}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Subscribe to App</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <p className="font-weight-bold col-md-4">Application name: </p>
          <p className="sub-text col-md-8">{app?.name}</p>
        </div>
        <div className="row">
          <p className="font-weight-bold col-md-4">Charging details: </p>
          {subscriptionNcs?.free ? (
            <p className="sub-text col-md-8">Charging free app</p>
          ) : (
            <p className="sub-text col-md-8">
              You will be charged
              {` ${subscriptionNcs?.frequency} ${subscriptionNcs?.currencyCode} ${subscriptionNcs?.amount} + VAT and SD`}
            </p>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-light"
          data-dismiss="modal"
          onClick={() => {
            hideSubscriptionModalAction();
          }}
        >
          Close
        </button>
        <button
          disabled={mainPageData.subscribing}
          className="btn btn-primary"
          type="button"
          data-toggle="modal"
          data-target="#verify-otp-modal"
          onClick={() => subscribingAction()}
        >
          <i
            className={
              mainPageData.subscribing ? "fas fa-spin fa-circle-notch" : ""
            }
          ></i>
          {mainPageData.subscribing ? "Subscribing..." : "Subscribe"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default SubscriptionModal;
